<div class="orders-create">
  <router-outlet></router-outlet>
</div>
